import React from "react";
import { Bar, Kpi, PartsTable } from "./NpdShared";
import { countByStatus, fmt, late, stg } from "./npdUtils";

const BuyerDashboard = ({ app }) => {
  const { me, lines, parts, today, go, openPart, advance } = app;
  const M = parts.filter((p) => p.buyerId === me.orgUserId);
  const c = countByStatus(M);
  const soon14 = (p) => p.s !== 1 && late(p, today) === 0 && p.target - today <= 14 * 864e5;
  const act = M.filter((p) => p.s !== 1 && (p.s === 3 || late(p, today) > 0 || soon14(p)))
    .sort((a, b) => (b.s === 3) - (a.s === 3) || late(b, today) - late(a, today) || a.target - b.target)
    .slice(0, 6);
  const pL = lines.map((l) => ({ l, m: M.filter((p) => p.L.id === l.id) })).filter((x) => x.m.length);

  return (
    <>
      <h2>My Dashboard</h2>
      <p className="sub">{me.name} · {M.length} parts assigned to you</p>
      <div className="tools">
        <button className="btn p" onClick={() => go("add")}>Add part</button>
      </div>
      <div className="kpis">
        <Kpi n={M.length} label="My parts" />
        <Kpi n={c[0]} label="In progress" color="ip" />
        <Kpi n={c[2]} label="Under review" color="rv" />
        <Kpi n={c[3]} label="Delayed" color="dl" />
        <Kpi n={M.filter(soon14).length} label="Due in 14 days" color="rv" />
        <Kpi n={M.filter((p) => late(p, today) > 0).length} label="Past target date" color="dl" />
        <Kpi n={c[1]} label="Completed" color="ok" />
      </div>
      <div className="panel">
        <h3>Needs your action</h3>
        {act.length ? act.map((p) => {
          const d = late(p, today);
          return (
            <div key={p.id} className="att" onClick={() => openPart(p.id)}>
              <span>{p.partNo} {p.name} · {stg(p)}</span>
              <span className={d ? "red" : ""}>{d ? `${d} days late` : `Due ${fmt(p.target)}`}</span>
            </div>
          );
        }) : <div className="empty">Nothing urgent. All your parts are on track.</div>}
      </div>
      <div className="panel">
        <h3>My parts by assembly line</h3>
        <div className="wrap">
          {pL.length ? (
            <table>
              <thead>
                <tr><th>Line</th><th>My parts</th><th>Delayed</th><th>Completed</th><th style={{ width: 200 }}>Status</th></tr>
              </thead>
              <tbody>
                {pL.map((x) => (
                  <tr key={x.l.id} className="r" onClick={() => go("tracker", { line: x.l.id })}>
                    <td>{x.l.name}</td>
                    <td>{x.m.length}</td>
                    <td className={x.m.some((p) => p.s === 3) ? "red" : ""}>{x.m.filter((p) => p.s === 3).length}</td>
                    <td>{x.m.filter((p) => p.s === 1).length}</td>
                    <td><Bar counts={countByStatus(x.m)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <div className="empty">No parts assigned yet. Use Add part to create one.</div>}
        </div>
      </div>
      <div className="panel">
        <h3>All my parts</h3>
        <PartsTable list={parts} showLine today={today} me={me} defaultMine
          onOpen={openPart} onAdvance={advance} />
      </div>
    </>
  );
};

export default BuyerDashboard;
